import { render } from "./SelectTokenModal.vue?vue&type=template&id=8d3bf910&scoped=true&ts=true"
import script from "./SelectTokenModal.vue?vue&type=script&lang=ts"
export * from "./SelectTokenModal.vue?vue&type=script&lang=ts"

import "./SelectTokenModal.vue?vue&type=style&index=0&id=8d3bf910&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d3bf910"]])

export default __exports__